module.exports = __webpack_public_path__ + "img/Google_white.c055077e.svg";